import { DEBUG, DEBUG_ALERT_MSG } from '../config';
import { isCurrentTabMaster } from './establishMultitabRole';
import { throttle } from './schedulers';

const SHOULD_SHOW_DEBUG_ALERT = false;

let showError = true;
let error: Error | undefined;

window.addEventListener('error', handleErrorEvent);
window.addEventListener('unhandledrejection', handleErrorEvent);

if (DEBUG && SHOULD_SHOW_DEBUG_ALERT) {
  window.addEventListener('focus', () => {
    if (!isCurrentTabMaster()) {
      return;
    }
    showError = true;
    if (error) {
      // eslint-disable-next-line no-alert
      window.alert(getErrorMessage(error));
      error = undefined;
    }
  });
  window.addEventListener('blur', () => {
    if (!isCurrentTabMaster()) {
      return;
    }
    showError = false;
  });
}

const throttleError = throttle((err) => {
  if (!SHOULD_SHOW_DEBUG_ALERT) {
    return;
  }

  if (showError) {
    // eslint-disable-next-line no-alert
    window.alert(getErrorMessage(err));
  } else {
    error = err;
  }
}, 1500);

export function handleError(err: Error | { message?: string } | unknown) {
  // eslint-disable-next-line no-console
  console.error(err);

  if (err instanceof Error) {
    import('./cacheRecovery')
      .then(({ detectAndRecoverCacheError }) => detectAndRecoverCacheError(err))
      .then((recovered) => {
        if (recovered) {
          return;
        }

        showErrorIfDebug(err);
      })
      .catch(() => {
        showErrorIfDebug(err);
      });
  } else {
    showErrorIfDebug(err);
  }
}

function showErrorIfDebug(err: Error | { message?: string } | unknown) {
  if (DEBUG) {
    const message = typeof err === 'object' && err !== null && 'message' in err
      ? String((err as { message?: unknown }).message)
      : undefined;
    if (
      typeof message === 'string'
      && (
        message.includes('STICKERSET_INVALID')
        || message.includes('Could not find a matching Constructor ID')
      )
    ) {
      return;
    }
    throttleError(err);
  }
}

function handleErrorEvent(e: ErrorEvent | PromiseRejectionEvent) {
  if (e instanceof ErrorEvent && e.message === 'ResizeObserver loop limit exceeded') {
    return;
  }

  e.preventDefault();
  handleError(e instanceof ErrorEvent ? (e.error || e.message) : e.reason);
}

function getErrorMessage(err: Error | { message?: string } | unknown): string {
  if (err == null) {
    return DEBUG_ALERT_MSG;
  }
  if (err instanceof Error) {
    return `${DEBUG_ALERT_MSG}\n\n${err.message}\n${err.stack ?? ''}`;
  }
  if (typeof err === 'object' && 'message' in err) {
    const msg = (err as { message?: unknown }).message;
    return `${DEBUG_ALERT_MSG}\n\n${typeof msg === 'string' ? msg : JSON.stringify(err)}`;
  }
  return `${DEBUG_ALERT_MSG}\n\n${typeof err === 'string' ? err : JSON.stringify(err)}`;
}
